import { Typography } from '@bb-ui/react-library/dist/components/Typography/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@bb-ui/react-library/dist/components/Checkbox';
import { FormControlLabel } from '@bb-ui/react-library/dist/components/FormControlLabel';
import { Tooltip } from '@bb-ui/react-library/dist/components/Tooltip';
import Badge from '@bb-ui/react-library/dist/components/Badge/Badge';
import { useStyles } from './UserIlluminateRoles.styles';

export interface UserIlluminateRoleCheckBoxProps {
    roleName: string;
    checked: boolean;
    disabled?: boolean;
    tooltipTitle?: NonNullable<React.ReactNode>;
    onChange: (roleName: string, checked: boolean) => void;
}

export const UserIlluminateRoleCheckbox: React.FunctionComponent<
    UserIlluminateRoleCheckBoxProps
> = ({ roleName, checked, disabled = false, tooltipTitle = '', onChange }) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const renderControl = () => (
        <div className={classes.wrapper}>
            <FormControlLabel
                label={t(`settings.illuminateRoles.${roleName}.displayName`)}
                control={
                    <Checkbox
                        onChange={(_, checked) => onChange(roleName, checked)}
                        checked={checked}
                        disabled={disabled}
                        data-testid={`user-roles-${roleName}-checkbox`}
                    />
                }
            />
            {roleName === 'BbDataAuthor' && (
                <Badge
                    position="inline"
                    badgeContent={t(
                        `settings.illuminateRoles.${roleName}.badge`,
                    )}
                    offScreenLabel={t(
                        `settings.illuminateRoles.${roleName}.badge`,
                    )}
                    color="indicatorPrimary"
                    data-testid="viewerBadge"
                    className={classes.badge}
                />
            )}
        </div>
    );

    return (
        <div className={classes.userRoleCheckbox}>
            {tooltipTitle ? (
                <Tooltip title={tooltipTitle}>{renderControl()}</Tooltip>
            ) : (
                renderControl()
            )}

            <div className={classes.userRoleAnnotation}>
                <Typography variant="caption" color="textPrimary">
                    {t(`settings.illuminateRoles.${roleName}.annotation`)}
                </Typography>
            </div>
        </div>
    );
};
